export default {
  basicInfo: '/report-api/v1/user/{user_id}/basic-info',
  cashflowCharts:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/cashflow-dashboard-charts',
  cashflowSummary:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/cashflow-summary',
  topRecurringExpenditures:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/bank-account-recurring-transactions/expenditures?limit=3&sort=desc',
  topRecurringIncomes:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/bank-account-recurring-transactions/incomes?limit=3&sort=desc',
  financialCredibility:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/financial-credibility',
  liquidity:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/liquidity',
  incomeStability:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/income-stability',
  rentStability:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/rent-stability',
  financialMarkers:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/financial-markers',
  events: 'report-api/v1/user/{user_id}/account_type/{account_type}/events',
  eventsFeed:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/events-feed',
  bankAccountsList:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/bank-accounts-list',
  bankAccountsFinancialStats:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/bank-accounts-financial-stats',
  recurringExpenditures:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/bank-account-recurring-transactions/expenditures',
  recurringIncomes:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/bank-account-recurring-transactions/incomes',
  transactions:
    '/report-api/v1/user/{user_id}/account_type/{account_type}/bank-account-transactions',
  similarTransactions:
    '/report-api/v1/bank-account-similar-transactions/{transaction_id}',
};

export const authenticationUrl =
  'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyC63A7wXQc8Geui3oD2j4QFJvv-9r1cjCI';

// const temporaryDomain = 'https://fs-react-panel-default-rtdb.firebaseio.com'; // OLD: firebase
export const temporaryDomain =
  'https://c75fe8c2-19d7-448e-bc15-ff06fe628045.mock.pstmn.io'; // NEW: postman mock server

export const temporaryEndpoints = {
  dashboard: {
    // NEW: postman mock server
    charts: `${temporaryDomain}/report-api/v1/dashboard/charts`,
    // OLD: firebase
    // charts: `${temporaryDomain}/dashboard/charts.json`,
  },
  // NEW: postman mock server
  reportsList: `${temporaryDomain}/report-api/v1/reports-list`,
  invitationsList: `${temporaryDomain}/report-api/v1/invitations-list`,
  teammatesList: `${temporaryDomain}/report-api/v1/teammates-list`,
  leaderboardList: `${temporaryDomain}/report-api/v1/leaderboard-list`,
  // OLD: firebase
  // reportsList: `${temporaryDomain}/reports-list.json`,
  // invitationsList: `${temporaryDomain}/invitations-list.json`,
  // teammatesList: `${temporaryDomain}/teammates-list.json`,
  // leaderboardList: `${temporaryDomain}/leaderboard-list.json`,
  developers: {
    // NEW: postman mock server
    keys: `${temporaryDomain}/report-api/v1/keys`,
    redirectsWeb: `${temporaryDomain}/report-api/v1/redirects-web`,
    redirectsMobile: `${temporaryDomain}/report-api/v1/redirects-mobile`,
    // OLD: firebase
    // keys: `${temporaryDomain}/keys.json`,
    // redirectsWeb: `${temporaryDomain}/redirects-web.json`,
    // redirectsMobile: `${temporaryDomain}/redirects-mobile.json`,
  },
  settings: {
    // NEW: postman mock server
    notificationEmails: `${temporaryDomain}/report-api/v1/notification-emails`,
    // OLD: firebase
    // notificationEmails: `${temporaryDomain}/notification-emails.json`,
  },
  profile: {
    // NEW: postman mock server
    userDetails: `${temporaryDomain}/report-api/v1/user-details`,
    // OLD: firebase
    // userDetails: `${temporaryDomain}/user-details.json`,
  },
  billings: {
    // NEW: postman mock server
    paymentMethod: `${temporaryDomain}/report-api/v1/billings/payment-method`,
    billingInfo: `${temporaryDomain}/report-api/v1/billings/billing-info`,
    planDetails: `${temporaryDomain}/report-api/v1/billings/plan-details`,
    invoiceHistory: `${temporaryDomain}/report-api/v1/billings/invoice-history`,
    // OLD: firebase
    // paymentMethod: `${temporaryDomain}/billings/payment-method.json`,
    // billingInfo: `${temporaryDomain}/billings/billing-info.json`,
    // planDetails: `${temporaryDomain}/billings/plan-details.json`,
    // invoiceHistory: `${temporaryDomain}/billings/invoice-history.json`,
  },
  upgrade: {
    // NEW: postman mock server
    calculations: `${temporaryDomain}/report-api/v1/upgrade/calculations`,
    details: `${temporaryDomain}/report-api/v1/upgrade/details`,
    // OLD: firebase
    // calculations: `${temporaryDomain}/upgrade/calculations.json`,
    // details: `${temporaryDomain}/upgrade/details.json`,
  },
  // NEW: postman mock server
  notifications: `${temporaryDomain}/report-api/v1/notifications`,
  magicLink: `${temporaryDomain}/report-api/v1/magic-link`,
  // OLD: firebase
  // notifications: `${temporaryDomain}/notifications.json`,
  // magicLink: `${temporaryDomain}/magic-link.json`,
  report: {
    // NEW: postman mock server
    basicInfo: `${temporaryDomain}/report-api/v1/user/{user_id}/basic-info`,
    cashflowCharts: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/cashflow-charts`,
    cashflowSummary: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/cashflow-summary`,
    topRecurringExpenditures: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/bank-account-recurring-transactions/expenditures?limit=3&sort=desc`,
    topRecurringIncomes: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/bank-account-recurring-transactions/incomes?limit=3&sort=desc`,
    financialCredibility: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/financial-credibility`,
    liquidity: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/liquidity`,
    incomeStability: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/income-stability`,
    rentStability: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/rent-stability`,
    financialMarkers: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/financial-markers`,
    events: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/events`,
    eventsFeed: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/events-feed`,
    bankAccountsList: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/bank-accounts-list`,
    bankAccountsFinancialStats: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/bank-accounts-financial-stats`,
    recurringExpenditures: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/bank-account-recurring-transactions/expenditures`,
    recurringIncomes: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/bank-account-recurring-transactions/incomes`,
    transactions: `${temporaryDomain}/report-api/v1/user/{user_id}/account_type/{account_type}/bank-account-transactions`,
    similarTransactions: `${temporaryDomain}/report-api/v1/bank-account-similar-transactions/{transaction_id}`,
    // OLD: firebase
    // basicInfo: `${temporaryDomain}/report/basics.json`,
    // cashflowSummary: `${temporaryDomain}/report/info.json`,
    // cashflowCharts: `${temporaryDomain}/report/timeseries-charts/data.json`,
    // topRecurringExpenditures: `${temporaryDomain}/report/transactions/recurring/expenditures/top.json`,
    // topRecurringIncomes: `${temporaryDomain}/report/transactions/recurring/incomes/top.json`,
    // financialCredibility: `${temporaryDomain}/report/financial-credibility.json`,
    // liquidity: `${temporaryDomain}/report/liquidity.json`,
    // incomeStability: `${temporaryDomain}/report/income-stability.json`,
    // rentStability: `${temporaryDomain}/report/rent-payment-stability.json`,
    // financialMarkers: `${temporaryDomain}/report/financial-markers.json`,
    // penalties: `${temporaryDomain}/report/penalties.json`,
    // events: `${temporaryDomain}/report/indicators.json`,
    // eventsFeed: `${temporaryDomain}/report/event-feed.json`,
    // bankAccountsList: `${temporaryDomain}/report/account-list.json`,
    // bankAccountsFinancialStats: `${temporaryDomain}/report/account-charts.json`,
    // recurringExpenditures: `${temporaryDomain}/report/transactions/recurring/expenditures.json`,
    // recurringIncomes: `${temporaryDomain}/report/transactions/recurring/incomes.json`,
    // transactions: `${temporaryDomain}/report/transactions.json`,
    // similarTransactions: `${temporaryDomain}/report/similar-transactions.json`,
  },
};
